/* ms-chrome.js - Msofas header + footer
   Mega menu (hover on desktop, tap on touch), mobile panel, footer accordions. */
(function () {
  var MOBILE = '(max-width: 900px)';
  var NO_RAIL = '(max-width: 1023px)';

  function initHeader(root) {
    // :not(.ms-hdr--bar) — liftTopBar() chen mot <div class="ms-hdr ms-hdr--bar">
    // vao dau <body>, no se la .ms-hdr DAU TIEN trong DOM. Khong loai tru thi
    // initHeader vo phai cai vo do, danh dau da init, va header that mat mega menu.
    var header = root.querySelector('.ms-hdr:not(.ms-hdr--bar)');
    if (!header || header.dataset.msInit === '1') { return; }
    header.dataset.msInit = '1';

    /* ---- mega menu ---- */
    var items = Array.prototype.slice.call(header.querySelectorAll('.nav-i.has-mega'));
    var openItem = null;
    var closeTimer = null;

    function close(item) {
      if (!item) { return; }
      item.classList.remove('open');
      var t = item.querySelector('.nav-a');
      if (t && t.tagName === 'BUTTON') { t.setAttribute('aria-expanded', 'false'); }
      if (openItem === item) { openItem = null; }
    }
    function open(item) {
      if (openItem && openItem !== item) { close(openItem); }
      item.classList.add('open');
      var t = item.querySelector('.nav-a');
      if (t && t.tagName === 'BUTTON') { t.setAttribute('aria-expanded', 'true'); }
      openItem = item;
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.nav-a');
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        open(item);
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { close(item); }, 140);
      });
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (trigger.tagName === 'BUTTON') { e.preventDefault(); }
          if (item.classList.contains('open')) { close(item); } else { open(item); }
        });
        trigger.addEventListener('focus', function () { open(item); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) { close(openItem); }
    });
    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) { close(openItem); }
    });

    /* ---- mobile chip rail: arrow scrolls, hides at the end ---- */
    var chips = header.querySelector('.hdr-chips');
    if (chips) {
      var track = chips.querySelector('.chips-track');
      var syncEnd = function () {
        chips.classList.toggle('at-end', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
      };
      chips.querySelector('.chips-next').addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.7, behavior: 'smooth' });
      });
      track.addEventListener('scroll', syncEnd, { passive: true });
      window.addEventListener('resize', syncEnd);
      var cur = track.querySelector('[aria-current]');
      if (cur) { track.scrollLeft = cur.offsetLeft - 15; }
      syncEnd();
    }

    /* ---- mobile panel ---- */
    var burger = header.querySelector('.burger');
    var panel = header.querySelector('.panel');
    if (burger && panel) {
      burger.addEventListener('click', function () {
        var isOpen = panel.classList.toggle('open');
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });
    }
    var searchBtn = header.querySelector('.util-search');
    if (searchBtn && burger && panel) {
      searchBtn.addEventListener('click', function () {
        if (!panel.classList.contains('open')) { burger.click(); }
        panel.scrollTop = 0;
        var input = panel.querySelector('input[type=search]');
        if (input) { input.focus(); }
      });
    }

    /* ---- mobile panel submenus ---- */
    Array.prototype.forEach.call(header.querySelectorAll('.panel-list .panel-row button'), function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('li');
        var isOpen = li.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    /* ---- close the panel when the rail comes back ---- */
    var railMq = window.matchMedia(NO_RAIL);
    function syncRail() {
      if (!railMq.matches && panel) {
        panel.classList.remove('open');
        if (burger) { burger.setAttribute('aria-expanded', 'false'); }
      }
    }
    if (railMq.addEventListener) { railMq.addEventListener('change', syncRail); } else { railMq.addListener(syncRail); }
    syncRail();
  }

  /* ---- basket: open the theme's quick-cart drawer instead of leaving the page ---- */
  function quickCartInstance() {
    var reg = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    var list = reg && reg.instances;
    if (!list) { return null; }
    for (var i = 0; i < list.length; i++) {
      if (list[i].type === 'quick-cart' && typeof list[i].openQuickCart === 'function') { return list[i]; }
    }
    return null;
  }

  function initCart(root) {
    var link = root.querySelector('[data-header-cart]');
    if (!link || link.dataset.msCart === '1') { return; }
    link.dataset.msCart = '1';

    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) { return; }
      var inst = quickCartInstance();
      if (!inst || !document.querySelector('.quick-cart__wrapper')) { return; } // fall through to /cart
      e.preventDefault();
      inst.openQuickCart();
    });

    /* The theme refreshes its own header markup only, and quantity edits inside the drawer
       fire no DOM event - so mirror the drawer subtotal whenever it changes. */
    var target = link.querySelector('.cnt');
    var drawer = document.querySelector('.quick-cart');
    if (target && drawer && window.MutationObserver) {
      var zero = link.getAttribute('data-empty-total') || '';
      var settle = null;
      var sync = function () {
        // debounce: the drawer is briefly empty mid-refresh
        clearTimeout(settle);
        settle = setTimeout(function () {
          // re-query: refreshQuickCart() replaces the footer markup, detaching any held node
          var subtotal = drawer.querySelector('.quick-cart__footer-subtotal span');
          if (subtotal) {
            var text = subtotal.textContent.trim().replace(/\s*[A-Z]{3}$/, '');
            if (text) { target.textContent = text; }
          } else if (zero && !drawer.querySelector('.quick-cart__item')) {
            // last item removed: the whole footer is gone, so there is nothing to mirror
            target.textContent = zero;
          }
        }, 150);
      };
      new MutationObserver(sync).observe(drawer, { childList: true, characterData: true, subtree: true });
      document.addEventListener('cart:updated', sync);
      document.addEventListener('cart:item-added', sync);
    }
  }

  function initFooter(root) {
    var footer = root.querySelector('.ms-ftr');
    if (!footer || footer.dataset.msInit === '1') { return; }
    footer.dataset.msInit = '1';

    var groups = Array.prototype.slice.call(footer.querySelectorAll('.fgroup'));
    if (!groups.length) { return; }
    var mq = window.matchMedia(MOBILE);
    function sync() {
      groups.forEach(function (g) { g.open = !mq.matches; });
    }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
  }

  /* ---- nhac .hdr-top ra khoi <header> de no dinh top that su ----
     Header co transform khi an (.is-hidden). Transform tao containing block, nen
     mot phan tu fixed/sticky NAM TRONG header se troi theo header chu khong dinh
     top. Vi vay phai dua .hdr-top ra ngoai, thanh con truc tiep cua <body>.
     Boc lai bang .ms-hdr de toan bo selector `.ms-hdr .hdr-top ...` van trung. */
  function liftTopBar() {
    var top = document.querySelector('.hdr-top');
    if (!top || top.parentElement.classList.contains('ms-hdr--bar')) { return; }
    var shell = document.createElement('div');
    shell.className = 'ms-hdr ms-hdr--bar';
    top.parentNode.removeChild(top);
    shell.appendChild(top);
    document.body.insertBefore(shell, document.body.firstChild);
  }

  /* ---- sit below any sticky bar pinned to the top ---- */
  function syncBarOffset() {
    if (!document.querySelector('.ms-hdr')) { return; }
    var height = 0;
    var bars = document.querySelectorAll('[class*="annoucement_bar_wrapper"], .ms-hdr--bar');
    Array.prototype.forEach.call(bars, function (bar) {
      var pos = getComputedStyle(bar).position;
      if (pos === 'sticky' || pos === 'fixed') { height += bar.getBoundingClientRect().height; }
    });
    document.documentElement.style.setProperty('--ms-bar-h', Math.round(height) + 'px');
  }

  /* ---- hide on scroll down, reveal on scroll up ---- */
  function initScrollHide() {
    var section = document.querySelector('.ms-header-section');
    if (!section || section.dataset.msHide === '1') { return; }
    section.dataset.msHide = '1';

    var last = window.scrollY;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY;
      var delta = y - last;
      if (Math.abs(delta) < 6) { return; }  // ignore jitter and rubber-banding
      last = y;

      // never hide near the top, or while a menu is open
      var menuOpen = section.querySelector('.nav-i.open, .panel.open');
      if (y <= section.offsetHeight + 40 || menuOpen) {
        section.classList.remove('is-hidden');
      } else {
        section.classList.toggle('is-hidden', delta > 0);
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  function init(root) {
    // initHeader truoc: no can header that, dung de liftTopBar xen ngang.
    initHeader(root);
    liftTopBar();
    initCart(root);
    initFooter(root);
    initScrollHide();
    syncBarOffset();
    // the bar is injected by an app, so re-measure once it has settled
    setTimeout(syncBarOffset, 1200);
    window.addEventListener('resize', syncBarOffset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.parentNode || document);
  });
})();

/* ── gop thanh countdown cua app vao .hdr-top ────────────────────────────
   Thanh do la cua app "Essential Countdown Timer Bar", no tu chen mot <div>
   sticky cao 61px thang vao <body>, ngoai moi section cua theme. Cong voi
   .hdr-top 37px la mat 98px truoc khi toi logo.

   Ta DOI NGUYEN node cua app vao trong .hdr-top chu khong boc ruot no ra:
   app van giu dung node cua minh nen dong ho van chay, va neu no render lai
   ben trong thi cung khong hong. Doi lai phai ep style bang !important —
   day la cho mong manh nhat, app doi class la phai sua theo.
   Muon het mong manh thi tat han app va cho header tu in mot dong khuyen mai. */
(function () {
  var SEL = '.essential_countdown_annoucement_bar_wrapper';
  var slot = document.querySelector('.ms-hdr .hdr-top .wrap');
  if (!slot) return;

  function merge() {
    var bar = document.querySelector(SEL);
    if (!bar || bar.closest('.hdr-top')) return !!bar;
    bar.classList.add('hdr-promo');
    slot.insertBefore(bar, slot.querySelector('.promises'));
    return true;
  }

  if (merge()) return;

  // App chen bar sau khi trang da load -> doi no xuat hien, toi da 10s.
  var mo = new MutationObserver(function () {
    if (merge()) mo.disconnect();
  });
  mo.observe(document.body, { childList: true });
  setTimeout(function () { mo.disconnect(); }, 10000);
})();

/* ── ba loi hua o ben phai: hien lan luot, fade ──────────────────────────
   Mac dinh CSS van hien ca ba; JS gan .is-rot moi doi sang che do xoay vong,
   nen tat JS hay JS loi thi van doc duoc du ba dong.
   Dung/chay lai khi rê chuot, khi focus ban phim, va khi tab bi an — vua do
   ton pin vua cho nguoi doc cham kip doc (WCAG 2.2.2). */
(function () {
  var box = document.querySelector('.ms-hdr .hdr-top .promises');
  if (!box) return;

  var items = Array.prototype.slice.call(box.children);
  if (items.length < 2) return;

  box.classList.add('is-rot');
  var i = 0;
  items[0].classList.add('is-on');

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var timer = null;
  function step() {
    items[i].classList.remove('is-on');
    i = (i + 1) % items.length;
    items[i].classList.add('is-on');
  }
  function play() { if (!timer) timer = setInterval(step, 4000); }
  function pause() { clearInterval(timer); timer = null; }

  play();
  box.addEventListener('mouseenter', pause);
  box.addEventListener('mouseleave', play);
  box.addEventListener('focusin', pause);
  box.addEventListener('focusout', play);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { pause(); } else { play(); }
  });
})();

/* ── predictive search cho o tim kiem tren header ───────────────────────
   Header moi khong chay component QuickSearch cua theme goc (no chi duoc
   khoi tao boi section "header" cu, khong con trong header group). Nen o day
   goi THANG dung endpoint va dung section 'quick-search-results' ma ban goc
   dung — markup + CSS ket qua giong het, chi khac phan vo o input.
   Neu theme doi ten section do thi cho nay phai sua theo. */
(function () {
  // Co 2 o tim kiem: thanh header (desktop) va trong panel mobile. Phai gan ca hai,
  // querySelector don le chi gan cai dau -> mobile khong co ket qua.
  Array.prototype.forEach.call(document.querySelectorAll('.ms-hdr [data-ms-search]'), wire);

  function wire(form) {
    var input = form.querySelector('[data-ms-search-input]');
    var drop = form.querySelector('[data-ms-search-drop]');
    var out = form.querySelector('[data-ms-search-results]');
    var viewAll = form.querySelector('[data-ms-search-viewall]');
    if (!input || !drop || !out) return;

    var endpoint = (window.theme && window.theme.routes && window.theme.routes.predictive_search_url) || '/search/suggest';
    var limit = form.getAttribute('data-limit') || '5';
    var cache = {};
    var timer = null;
    var seq = 0;

    function open() { drop.hidden = false; drop.classList.add('is-open'); }
    function close() { drop.classList.remove('is-open'); drop.hidden = true; }

    function render(html, term) {
      var node = new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-search-results');
      if (!node) return close();
      drop.setAttribute('data-results-count', node.getAttribute('data-results-count') || '0');
      out.innerHTML = node.innerHTML;
      drop.setAttribute('data-loading', 'false');
      if (viewAll) {
        var label = viewAll.getAttribute(term ? 'data-label-with-query' : 'data-label') || '';
        viewAll.textContent = label.replace('{{ query }}', term);
      }
  }

  function run(term) {
    var p = new URLSearchParams();
    p.set('section_id', 'quick-search-results');
    p.set('q', term);
    p.set('resources[limit_scope]', 'each');
    p.set('resources[limit]', limit);
    if (window.theme && window.theme.searchableFields) {
      p.set('resources[options][fields]', window.theme.searchableFields);
    }
    var url = endpoint + '?' + p.toString();
    open();
    if (cache[url]) return render(cache[url], term);

    out.innerHTML = '';
    drop.setAttribute('data-loading', 'true');
    // Moi lan go lai tang seq: response ve cham cua tu khoa cu bi bo qua.
    var mine = ++seq;
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) { cache[url] = text; if (mine === seq) render(text, term); })
      .catch(function () { if (mine === seq) close(); });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) return close();
    timer = setTimeout(function () { run(term); }, 300);
  });
  input.addEventListener('focus', function () {
    if (input.value.trim().length > 1 && out.innerHTML) open();
  });
  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); input.blur(); }
  });
  }
})();
